<template>
  <nav aria-label="Progress">
    <ol
      role="list"
      class="divide-y divide-gray-300 rounded-md border border-gray-300 md:flex md:divide-y-0"
    >
      <li
        v-for="(step, stepIndex) in providedSteps"
        :key="stepIndex"
        class="relative md:flex md:flex-1"
      >
        <!-- Completed Step -->
        <a
          v-if="step.completed"
          href="#"
          class="group flex w-full items-center"
        >
          <span class="flex items-center px-6 py-4 text-sm font-medium">
            <span
              class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-teal-600 group-hover:bg-teal-800"
            >
              <!-- Heroicon name: solid/check -->
              <svg
                class="h-6 w-6 text-white"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
            <span class="ml-4 text-sm font-medium text-gray-900">{{
              step.title
            }}</span>
          </span>
        </a>
        <!-- Current step -->
        <a
          v-if="step.active && !step.completed"
          href="#"
          class="flex items-center px-6 py-4 text-sm font-medium"
          aria-current="step"
        >
          <span
            class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border-2 border-teal-600"
          >
            <span class="text-teal-600">0{{ stepIndex + 1 }}</span>
          </span>
          <span class="ml-4 text-sm font-medium text-teal-600">{{
            step.title
          }}</span>
        </a>
        <!-- Inactive step -->
        <a
          v-if="!step.active && !step.completed"
          href="#"
          class="group flex items-center"
        >
          <span class="flex items-center px-6 py-4 text-sm font-medium">
            <span
              class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border-2 border-gray-300 group-hover:border-gray-400"
            >
              <span class="text-gray-500 group-hover:text-gray-900">0{{ stepIndex + 1 }}</span>
            </span>
            <span
              class="ml-4 text-sm font-medium text-gray-500 group-hover:text-gray-900"
            >{{ step.title }}</span>
          </span>
        </a>

        <!-- Arrow separator for lg screens and up -->
        <div
          v-if="stepIndex !== steps.length - 1"
          class="absolute right-0 top-0 hidden h-full w-5 md:block"
          aria-hidden="true"
        >
          <svg
            class="h-full w-full text-gray-300"
            viewBox="0 0 22 80"
            fill="none"
            preserveAspectRatio="none"
          >
            <path
              d="M0 -2L20 40L0 82"
              vector-effect="non-scaling-stroke"
              stroke="currentColor"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'StepsNavigation',

  props: {
    steps: {
      type: Array,
      default: () => [
        {
          active: true,
          completed: true,
          title: 'First',
        },
        {
          active: true,
          completed: false,
          title: 'Second',
        },
        {
          active: false,
          completed: false,
          title: 'Last',
        },
      ],
    },
  },

  data() {
    return {
      providedSteps: this.steps,
    }
  },

  methods: {
    start() {
      this.providedSteps.forEach((step, index) => {
        step.active = index === 0
        step.completed = false
      })
    },
  },
}
</script>
